import { h } from 'preact';
import PropTypes from 'prop-types';
import { forwardRef } from 'preact/compat';

import { getClassNames } from '../../../../utils/classnames-utils';

import { modifierList } from './props-list';

const SetOfCards = forwardRef(
  (
    {
      render,
      cards = [],
      modifiers,
      index,
    },
    ref
  ) => {
    const setOfCardsModifiers = getClassNames('c-set-of-cards', modifiers);
    return (
      <div ref={ref} className={setOfCardsModifiers} data-index={index}>
        {cards.map((item, index) => render(item, index))}
      </div>
    );
  }
);

SetOfCards.propTypes = {
  render: PropTypes.func.isRequired,
  cards: PropTypes.array.isRequired,
  modifiers: PropTypes.arrayOf(PropTypes.oneOf(modifierList)),
  index: PropTypes.number,
};

export default SetOfCards;
